import { useBoundStore } from '../../../../stores';
import { Delete, Edit, CropFree } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Columns(handleDelete, handleRelation, handleBarcode) {
  const navigate = useNavigate();
  const textPool = useBoundStore((state) => state.textPool);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  return [
    {
      field: 'productName',
      headerName: "Ürün Adı",
      width: 120,
    },
    {
      field: 'barcodeNumber',
      headerName: "Barkod Numarası",
      width: 230,
      renderCell: (data) => (
        <div className='w-full flex justify-between items-center'>
          <span>{data.row.barcodeNumber}</span>
          <IconButton onClick={() => { handleBarcode(data.row); }}>
            <CropFree />
          </IconButton>
        </div>
      ),
    },
    {
      field: 'productType',
      headerName: "Ürün Tipi",
      width: 120,
    },
    {
      field: 'status',
      headerName: "Durum",
      width: 80,
    },
    { field: 'description', headerName: 'Açıklama', width: 150 },
    {
      field: 'createdAt',
      headerName: textPool['Oluşturma Tarihi'],
      width: 150,
      notFilter: true,
      renderCell: (data) =>
        data.row.createdAt ? (
          <div>
            {data?.row?.createdAt
              ? new Date(data?.row?.createdAt).toLocaleString('tr')
              : ''}
          </div>
        ) : (
          <span className="font-bold">Eşleşme Yok</span>
        ),
    },
    {
      field: 'actions',
      headerName: 'İşlemler',
      width: 100,
      sortable: false,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            <IconButton
              onClick={() => {
                navigate(`/definitions/products/#${params.row.barcodeNumber}`);
                toggleLeftDrawer();
              }}
            >
              <Edit />
            </IconButton>
            <IconButton onClick={() => handleDelete(params.row)}>
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];
}
export { Columns as columns };
